import { Injectable } from '@angular/core';
import { StatefulValue } from '@workflow/class/stateful-value.class';
import { LogicFnContext } from '@workflow/service/logic/logic.service';
/**
 * Methods on this service get registered as 'logic functions' on LogicService
 */
@Injectable({
  providedIn: 'root'
})
export class CardValidationFunctionsService {
  constructor() {}

  /**
   * Validate Auto liabilities to make sure credit check has been run
   * @param context amount card field context
   */
  public arrayNotEmpty = (context: LogicFnContext, arrayStoragePath: string): boolean => {
    if (StatefulValue.arraySize(arrayStoragePath) === 0) {
      return false;
    }
    return true;
  };

  public liabilityAvailable = (
    context: LogicFnContext,
    arrayStoragePath: string,
    dontHaveLiability: boolean,
    hasLender: boolean
  ): boolean => {
    if (dontHaveLiability && StatefulValue.arraySize(arrayStoragePath) === 0 && !hasLender) {
      return false;
      // eslint-disable-next-line eqeqeq
    } else if ((!dontHaveLiability || StatefulValue.arraySize(arrayStoragePath) != 0) && !hasLender) {
      return false;
    } else if (!dontHaveLiability && StatefulValue.arraySize(arrayStoragePath) === 0) {
      return false;
    }
    return true;
  };
}
